import 'react-bootstrap-typeahead/css/Typeahead.css';
import 'react-bootstrap-typeahead/css/Typeahead.bs5.css';

import { useQuery } from '@tanstack/react-query';
import { ORDER_TYPE } from 'khufu-legos';
import { useState } from 'react';
import { Option } from 'react-bootstrap-typeahead/types/types';

import { getCustomers } from '../../../apis/queries';
import Loader from '../../../components/Loader';
import { Customer } from '../../../types';
import { CART_KEY, PREPARED_ORDER_KEY } from '../../../utils/tenant';
import { GET_CUSTOMERS_KEY } from '../../Customers/Customers';
import StepOne from './StepOne';
import StepThree from './StepThree';
import StepTwo from './StepTwo';

const CreateOrder = () => {
  const [activeStep, setActiveStep] = useState(1);
  const [selectedCustomer, setSelectedCustomer] = useState<Option[]>([]);
  const [orderType, setOrderType] = useState<ORDER_TYPE>(ORDER_TYPE.EXPRESS);

  const compositeQueryKey = [GET_CUSTOMERS_KEY];
  const { data, isLoading } = useQuery({
    queryKey: compositeQueryKey,
    queryFn: () => getCustomers({ isActive: true, limit: 10000 })
  });

  const customers = data?.results;

  const handleCustomerChange = (option: Option[]) => {
    setSelectedCustomer(option);
    localStorage.removeItem(CART_KEY);
    localStorage.removeItem(PREPARED_ORDER_KEY);
  };

  const resetCustomerSelection = () => {
    setSelectedCustomer([]);
  };

  if (isLoading) {
    return (
      <div className="d-flex justify-content-center align-items-center vh-100">
        <Loader />
      </div>
    );
  }

  return (
    <>
      {activeStep === 1 && (
        <StepOne
          activeStep={activeStep}
          customers={customers}
          handleCustomerChange={handleCustomerChange}
          selectedCustomer={selectedCustomer}
          setActiveStep={setActiveStep}
          orderType={orderType}
          setOrderType={setOrderType}
        />
      )}
      {activeStep === 2 && (
        <StepTwo
          activeStep={activeStep}
          setActiveStep={setActiveStep}
          customer={selectedCustomer[0] as Customer}
          resetCustomerSelection={resetCustomerSelection}
          orderType={orderType}
        />
      )}
      {activeStep === 3 && (
        <StepThree activeStep={activeStep} setActiveStep={setActiveStep} customer={selectedCustomer[0] as Customer} />
      )}
    </>
  );
};

export default CreateOrder;
